import { Map } from 'immutable';
import { AnyAction } from 'redux';

import Campaign from 'entities/campaign/model';

import { ADD, ADD_MULTIPLE, UPDATE } from './constants';

export type CampaignState = Map<string, Campaign>;

const initialState = Map<string, Campaign>();

export default (state = initialState, action: AnyAction): CampaignState => {
  switch (action.type) {
    case ADD:
      return state.set(action.campaign.id, action.campaign);

    case ADD_MULTIPLE:
      return state.merge(action.campaigns);

    case UPDATE:
      return state.set(action.campaign.id, action.campaign);

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
